// When a document is torn down the browser cancels its in-flight requests,
// and the cancellation surfaces as a response-less failure: WebKit fires
// `error` (axios "Network Error"), Gecko fires `abort` ("Request aborted").
// Blink and Gecko cancel when the new document commits, after `pagehide`.
// WebKit cancels as soon as the navigation is allowed to proceed, before the
// new page has even started loading, so `pagehide` comes too late there.
// `beforeunload` is dispatched at navigation start in every engine, so it is
// armed too, but only for a grace window: a navigation can be abandoned after
// `beforeunload` (a deep link into the app, a download, the user staying),
// and a flag stuck at true would hide every real failure that followed.
// `pageshow` clears both for a bfcache restore.
const NAVIGATION_GRACE_MS = 5_000;

let unloading = false;
let navigationStartedAt = -Infinity;

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", () => {
    navigationStartedAt = Date.now();
  });
  window.addEventListener("pagehide", () => {
    unloading = true;
  });
  window.addEventListener("pageshow", () => {
    unloading = false;
    navigationStartedAt = -Infinity;
  });
}

export const isPageUnloading = () =>
  unloading || Date.now() - navigationStartedAt < NAVIGATION_GRACE_MS;
